import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import HeroSection1 from "./components/HeroSection1";
import Header from "./components/Header";
import Dashboard from "./Dashboard";
import About from "./pages/About";
import DataRequestForm from "./components/DataRequestFormNew1";
import MapView from "./pages/MapViewnew824";
import Diwasa from "./pages/Diwasa";
import Resources from "./pages/Resources";

// 👇 Make sure this path matches your file: src/analytics.js
import { trackPageView } from "./Analytics";

const SCALE = 0.85; // render app at 85%
const LOCK_BROWSER_ZOOM = true; // set to false if you don’t want to block Ctrl/+/- and pinch

function FixedScale({ children }) {
  // Prefer CSS zoom (Chromium); fallback to transform for Firefox/Safari
  const supportsZoom =
    typeof CSS !== "undefined" &&
    CSS.supports &&
    CSS.supports("zoom", 1);

  // Optional: block browser zoom so user zoom level doesn't change the apparent size
  useEffect(() => {
    if (!LOCK_BROWSER_ZOOM) return;

    // Ensure meta viewport prevents pinch-zoom on mobile
    let originalMeta = null;
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      originalMeta = meta.getAttribute("content");
      meta.setAttribute(
        "content",
        "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      );
    } else {
      const m = document.createElement("meta");
      m.name = "viewport";
      m.content =
        "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
      document.head.appendChild(m);
    }

    // Prevent Ctrl/⌘ + wheel and Ctrl/⌘ + (+/-/0)
    const onWheel = (e) => {
      if (e.ctrlKey) e.preventDefault();
    };
    const onKeyDown = (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        (e.key === "+" || e.key === "-" || e.key === "=" || e.key === "0")
      ) {
        e.preventDefault();
      }
    };
    window.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("keydown", onKeyDown, true);

    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("keydown", onKeyDown, true);
      // (optional) restore previous viewport meta
      if (meta && originalMeta) meta.setAttribute("content", originalMeta);
    };
  }, []);

  const wrapperStyle = supportsZoom
    ? { zoom: SCALE } // Chromium/Edge
    : {
        // Firefox/Safari fallback
        transform: `scale(${SCALE})`,
        transformOrigin: "top left",
        width: `${100 / SCALE}%`,
        height: `${100 / SCALE}%`,
      };

  return <div style={wrapperStyle}>{children}</div>;
}

/**
 * Wrapper so we can use useLocation and fire GA page_view
 */
function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    // 🔥 send page_view to Google Analytics
    trackPageView(path);
  }, [location]);

  return (
    <FixedScale>
      <Routes>
        {/* Landing Page (no Header) */}
        <Route path="/" element={<HeroSection1 />} />

        {/* Dashboard Page */}
        <Route
          path="/dashboard"
          element={
            <>
              <Header />
              <main>
                <Dashboard />
              </main>
            </>
          }
        />

        <Route
          path="/diwasa"
          element={
            <>
              <Header />
              <main>
                <Diwasa />
              </main>
            </>
          }
        />

        {/* About Page */}
        <Route
          path="/about"
          element={
            <>
              <Header />
              <main>
                <About />
              </main>
            </>
          }
        />

        {/* Map Page */}
        <Route
          path="/map"
          element={
            <>
              <Header />
              <main>
                <MapView />
              </main>
            </>
          }
        />
         <Route
            path="/Resources"
            element={
              <>
                <Header />
                <main>
                  <Resources/>
                </main>
              </>
            }
            />
        <Route
          path="/requestdataaccess"
          element={
            <>
              <Header />
              <main>
                <DataRequestForm />
              </main>
            </>
          }
        />

        {/* Gemini Chat route placeholder if you add it later */}
        {/* <Route path="/chat" element={<GeminiChatPage />} /> */}
      </Routes>
    </FixedScale>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
